import script from "./PromptPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./PromptPanel.vue?vue&type=script&lang=ts&setup=true"

import "./PromptPanel.vue?vue&type=style&index=0&id=370579da&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-370579da"]])

export default __exports__